<template>
   <v-card :elevation="6" class="mx-auto pa-6 ml-2" >
    <grafico-barras
      :title="$tc('label.dash_liquidado_vs_previsto', 1)"
      :idGrafico="'previsto_liquidado'"
      :category-field="`mesAno`"
      :qtdColunasLegenda="qtdColunasLegenda"
      :value-fields="valueFields"
      :dados="dados"
      :colors="colors"
      :titleRodape="$tc('label.mes', 1)"
      :unit-y-axis="`${$t('label.unidade_dinheiro')} `"/>
  </v-card>
</template>
<script>

import { buscarDadosGraficoPrevistoLiquidado } from '../../../../common/resources/akzo-dashboard-sustentabilidade';
import GraficoBarras from '../../graficos/GraficoBarras';

export default {
  name: 'GraficoBarrasPrevistoLiquidado',
  props: {
    filtro: {
      type: Object,
    },
  },
  watch: {
    filtro: {
      handler() {
        this.filtroAplicado = this.filtro;
        this.buscarDadosGrafico();
      },
    },
  },
  computed: {
    isDadosGrafico() {
      return this.dados && this.dados.length > 0;
    },
  },
  components: {
    GraficoBarras,
  },
  data() {
    return {
      dados: [],
      valueFields: [],
      listValueFields: [
        'previsto',
        'liquidado',
      ],
      qtdColunasLegenda: 0,
      loading: false,
      filtroAplicado: this.filtro,
      colors: ['#4285f4', '#ff9901'],
    };
  },
  methods: {
    buscarDadosGrafico() {
      buscarDadosGraficoPrevistoLiquidado(this.filtroAplicado, this.$resource)
        .then((response) => {
          this.dados = response.data.dados;
          this.qtdColunasLegenda = this.valueFields.length;
          this.valueFields = this.listValueFields.map((v) => {
            const item = {
              balloonText: `${this.capitalize(v)} : ${this.$t('label.unidade_dinheiro')} [[value]]`,
              title: this.capitalize(v),
              valueField: v,
              type: 'column',
            };
            return item;
          });
        }).catch((err) => {
          this.$error(this, err);
        });
    },
    capitalize(str) {
      if (typeof str !== 'string') {
        return '';
      }
      return str.charAt(0).toUpperCase() + str.substr(1);
    },
  },
};
</script>
